import { ContentSection, HeroBackground, HeroSection, ImageGrid, StatsGrid } from "../../utils/IndustriesData/IndustriesData";

const CampaignPage = () => {
  const heroData = {
    logo: null, // Add your logo URL here
    title: 'Nestle S26',
    subtitle:
      'Leverage KOL to educate influencers regarding benefits of the product',
    qrCode: null, // Add QR code URL here
    videoThumbnail: null,
  };

  const impactStats = [
    { value: '12M+', label: 'Total Reach' },
    { value: '90%', label: 'Target Audience Reached' },
    { value: '85%', label: 'Engagement Rate' },
    { value: '60%', label: 'Brand Awareness Lift' },
  ];

  const executionImages = [
    {
      placeholder: 'Click on the image above each here',
      caption: 'Event Photo 1',
    },
    {
      placeholder: 'Click on the image above each here',
      caption: 'Event Photo 2',
    },
  ];

  return (
    <div className="min-h-screen">
      {/* Add your Header component here */}

      {/* Spacer to prevent navbar overlap - adjust pt-20 or pt-24 based on your navbar height */}
      <div className="pt-20">
        <HeroSection {...heroData} />
      </div>

      <ContentSection title="Overview" bgColor="">
        <p>Subtitle mentioned over here to boot.</p>
        <p>
          Nestle's objective was to increase sales of their baby formula product
          by creating promotional campaign around Nestle's brand that ties with
          the nutritional benefits for parameters. Coco AR was used to create an
          interactive 3D & AR experience with fully animated assets. Baby's
          growth tracker was integrated. The AR experience was designed to guide
          users through their toddler's key health milestones and teach them
          about growth and developmental stages, correlating key nutrients to
          their role and benefits. Coco AR SDK was developed & integrated in the
          client's in-house app to enable this AR experience. It featured 1, 2,
          3, Products for newborns, infants, and toddlers.
        </p>
      </ContentSection>

      <ContentSection title="Execution" bgColor="">
        <p>
          This gave Nestle users an innovative, fun and localized to come up
          with a proposal to discuss a solution that will be easy to execute and
          understand in addition to reading a memorable experience for both the
          Doctor and NE consultants. A app is created to the client to enter
          each and expert specify points of solution leveraged AR technology to
          make it an attractive and interactive experience for both the Doctor
          and NE consultants.
        </p>
        <p>
          For Nestle's S26 brand, we successfully delivered an Instant App-based
          AR experience designed to drive doctor engagement and therapeutic
          insights. The solution enabled elements for the pharmaceutical
          environment while capturing doctors interaction analytics for both
          doctors and users, including location-based analytics, physical
          engagement data, NE personnel performance review, individual doctor
          prescription data, repeat doctors/users, session length, view
          completion and focused volume including comparison to contest highly
          realistic, interactive and gamified models.
        </p>

        <div className="mt-8">
          <ImageGrid images={executionImages} columns={2} />
        </div>
      </ContentSection>

      <ContentSection title="Impact" bgColor="">
        <p>
          Success of the project was gauged via disseminated web campaigns in 12
          sites reducing the overall cost of dissemination by ~75%. The campaign
          was deployed to the targeted audience at specified dates. 90% although
          the target was only 60% as the quality is of very high standard.
        </p>
        <p>
          Video ad campaign distributed 90% of the audience reached through
          social media and email marketing. Application attracted 80% downloads
          from the targeted audience and a session length of ~150 seconds
          resulting in impressive ~85% completion rate. The app saw ~45K
          downloads and ~85K session plays in total in iOS and Android
          application stores respectively.
        </p>

     
      </ContentSection>

      {/* Add your Footer component here */}
    </div>
  );
};

export default CampaignPage;
